"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createContactReferenceResolver = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _createBatchedReferenceResolver = _interopRequireDefault(require("reference-resolvers/lib/createBatchedReferenceResolver"));

var _CacheKeys = _interopRequireDefault(require("reference-resolvers/constants/CacheKeys"));

var _ReferenceObjectTypes = _interopRequireDefault(require("reference-resolvers/constants/ReferenceObjectTypes"));

var _ContactSearchAPI = require("reference-resolvers/api/ContactSearchAPI");

var createContactReferenceResolver = function createContactReferenceResolver(options) {
  return (0, _createBatchedReferenceResolver.default)((0, _extends2.default)({
    cacheKey: _CacheKeys.default.CONTACTS,
    createFetchByIds: function createFetchByIds(opts) {
      return (0, _ContactSearchAPI.createGetObjectsByIds)(opts)(_ReferenceObjectTypes.default.CONTACT);
    },
    createFetchSearchPage: function createFetchSearchPage(opts) {
      return (0, _ContactSearchAPI.createSearchObjects)(opts)(_ReferenceObjectTypes.default.CONTACT);
    },
    fetchByIds: (0, _ContactSearchAPI.getObjectsByIds)(_ReferenceObjectTypes.default.CONTACT),
    fetchSearchPage: (0, _ContactSearchAPI.searchObjects)(_ReferenceObjectTypes.default.CONTACT)
  }, options));
};

exports.createContactReferenceResolver = createContactReferenceResolver;

var _default = createContactReferenceResolver();

exports.default = _default;